import type { RouteRecordRaw } from 'vue-router'

const StockTakeListPage = () => import('./pages/StockTakeListPage.vue')
const StockTakeRegisterPage = () => import('./pages/StockTakeRegisterPage.vue')
const StockTakeReviewPage = () => import('./pages/StockTakeReviewPage.vue')

const stockTakeRoutes: RouteRecordRaw[] = [
  {
    name: 'inventory-stock-takes',
    path: 'stock-takes',
    component: StockTakeListPage,
    meta: { requiresAuth: true },
  },
  {
    name: 'inventory-stock-take-register',
    path: 'stock-takes/register',
    component: StockTakeRegisterPage,
    meta: { requiresAuth: true },
  },
  {
    name: 'inventory-stock-take-review',
    path: 'stock-takes/:uuid/review',
    component: StockTakeReviewPage,
    meta: { requiresAuth: true },
    props: true,
  },
]

export default stockTakeRoutes
